import React from "react";
import { FaPhone } from "react-icons/fa/";
import { FaEnvelope } from "react-icons/fa/";
import { FaInstagram } from "react-icons/fa/";




const Footer = props => {
	return (
    	<React.Fragment>
    		<section className='footer mt-5'>
				<div className='container'>
					<div className='row'>
						<div className='col-12 col-md-4 text-left pt-4'>
							<h5 className='lead'>Contact Us</h5>
							<a className='footer-link' href='tel:+64 27 4875 730'><FaPhone/>&nbsp;&nbsp; +64 27 4875 730</a>
							<a className='footer-link' href='mailto:info@blissretreat.co.nz'><FaEnvelope/>&nbsp;&nbsp; info@blissretreat.co.nz</a>
						</div>
						<div className='col-12 col-md-4 text-left pt-4'>
							<h5 className='lead'>Follow Us</h5>
							<a className='footer-link' href='https://instagram.com/blissretreat'><FaInstagram/> Instagram</a>
							{/*<a className='footer-link' href='https://facebook.com/back2basicsnz'><FaFacebook/> Facebook</a>*/}

						</div>
						<div className='col-12 col-md-4 text-left pt-4'>
							<h5 className='lead'>Quick Links</h5>
							<a className='footer-link' href='/#'>Home</a>
							<a className='footer-link' href="/#eating-and-drinking">Eating & Drinking</a>
							<a className='footer-link' href="/#things-to-do">Things to do</a>
							<a className='footer-link' href="/#faq">Faq</a>
                            <a className='footer-link' href='/packages'>Packages</a>
							<a className='footer-link' href='/bookings'>Bookings</a>
						</div>
					</div>
				</div>
				<hr className='text-white'/>
				<img src='/images/logo-white.png' alt='Bliss Retreat'/>
				<p style={{fontSize:'.7em'}}>WAIHI, NEW ZEALAND</p>
    		</section>
    		<style jsx='true'>
    		{`
    			.footer {
    				background: #316220;
    				text-align: center;
    				color: white;
    				padding: 10px;
    			}

    			.footer img {
    				width: 100px;
    			}

    			.footer hr {
    				border-top: 1px solid #fff;
    			}

    			.footer-link{
    				color:white;
    				font-weight:100;
    				display:block;
    			}
    			.footer-link:hover {
    				color:white;
    				text-decoration:none;
    			}
    		`}</style>
    	</React.Fragment>
    )
}

export default Footer